export type PhotoSaveStage = "waiting" | "uploading" | "checking" | "ready";

export interface PhotoProgress {
  phase: "preparing" | "uploading" | "saving" | "reconciling";
  photos: Array<{ fileName: string; stage: string }>;
}

export type PhotoProgressCallback = (progress: PhotoProgress) => void;

/** Each update describes real work. Upload completion is not item-save completion. */
export function photoProgressTracker(fileNames: string[], onProgress?: PhotoProgressCallback) {
  const photos = fileNames.map((fileName) => ({ fileName, stage: "waiting" }));
  onProgress?.({ phase: "uploading", photos: photos.map((photo) => ({ ...photo })) });
  return (index: number, stage: PhotoSaveStage) => {
    photos[index] = { ...photos[index], stage };
    onProgress?.({ phase: "uploading", photos: photos.map((photo) => ({ ...photo })) });
  };
}
